import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from '../ui';
import { Shield } from 'lucide-react';
import PrivacyPolicyContent from './PrivacyPolicyContent';

/**
 * Modal bloccante per accettazione privacy policy
 * Appare al primo login se privacyAccepted è false
 */
function PrivacyModal({ open }) {
  const { acceptPrivacy } = useAuth();
  const [isAccepted, setIsAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAccept = async () => {
    if (!isAccepted) return;

    setIsLoading(true);
    try {
      await acceptPrivacy();
    } catch (error) {
      // Errore gestito nel context
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-lg"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        hideCloseButton
      >
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Shield className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
            <DialogTitle className="text-base sm:text-lg">Informativa sulla Privacy</DialogTitle>
          </div>
          <DialogDescription className="text-sm">
            Prima di continuare, ti chiediamo di leggere e accettare la nostra
            informativa sulla privacy.
          </DialogDescription>
        </DialogHeader>

        <div 
          className="max-h-48 sm:max-h-64 overflow-y-auto border rounded-md p-3 sm:p-4"
          style={{
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <PrivacyPolicyContent />
        </div>

        <div className="flex items-start gap-3 mt-3 sm:mt-4 p-3 border border-border rounded-lg">
          <input
            type="checkbox"
            id="privacy-accept"
            checked={isAccepted}
            onChange={(e) => setIsAccepted(e.target.checked)}
            className="mt-0.5 h-5 w-5 rounded border-gray-300 text-primary focus:ring-primary flex-shrink-0"
          />
          <label htmlFor="privacy-accept" className="text-xs sm:text-sm cursor-pointer leading-relaxed">
            Dichiaro di aver letto e compreso l'informativa sulla privacy e
            acconsento al trattamento dei miei dati personali.
          </label>
        </div>

        <DialogFooter>
          <Button
            onClick={handleAccept}
            disabled={!isAccepted}
            isLoading={isLoading}
            className="w-full sm:w-auto min-h-[48px] touch-manipulation"
          >
            Accetta e continua
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default PrivacyModal;
